<template>
  <div>
    <Box1></Box1>
    <Box2></Box2>
    <Box3></Box3>
    <Box4></Box4>
    <Box5></Box5>
    <Test></Test>
  </div>
</template>

<script>
import Box1 from "@/views/home/programming/box/box1.vue";
import Box2 from "@/views/home/programming/box/box2.vue";
import Box3 from "@/views/home/programming/box/box3.vue";
import Box4 from "@/views/home/programming/box/box4.vue";
import Box5 from "@/views/home/programming/box/box5.vue";
import Test from "@/components/test";
export default {
  components: { Box1, Box2, Box3, Box4, Box5, Test },
  data() {
    return {};
  },
  methods: {}
};
</script>

<style lang="scss" scoped>
.hover-scale {
  transform: scale(1.05);
  transition: transform 0.3s ease-in-out;
}
.hover-scale1 {
  transform: scale(1.1);
  transition: transform 0.3s ease-in-out;
}
.referral1 {
  height: 900px;
  background: #fafbff;
  .column {
    width: 62.5%;
    // background: #1633a8;
    margin-top: 100px;
  }
  .title {
    font-size: 30px;
    font-family: Microsoft YaHei;
    font-weight: bold;
    color: #333333;
  }
  .ul {
    padding: 20px;
    color: #6b7182;
    li {
      height: 70px;
    }
  }

  .left {
    margin-top: 94px;
  }

  .right {
    // background-color: brown;
    height: 500px;
    width: 800px;
    margin-top: 94px;
    display: flex;
    justify-content: flex-end;
    flex-direction: column;
    align-items: flex-end;
    .login100-pic {
      width: 634px;
      cursor: pointer;
    }

    .image {
      max-width: 100%;
    }
  }
}

.referral2 {
  height: 1306px;
  background-color: #ffffff;
}
.referral3 {
  height: 800px;
  width: 100%;
  background-color: #fafbff;
  .column {
    width: 63%;
  }
  .images {
    // width: 62.5%;
    margin-top: 50px;
    height: 440px;
  }
}
</style>



// WEBPACK FOOTER //
// src/views/home/programming/index.vue